(function () {
  function initEofyProductsDisplay(root) {
    if (!root || root.dataset.eofyProductsDisplayInit === 'true') return;
    root.dataset.eofyProductsDisplayInit = 'true';

    var nav = root.querySelector('.eofy-products-display__nav');
    var fillFixed = root.querySelector('.eofy-products-display__fill-fixed');
    var anchorLinks = root.querySelectorAll('.eofy-products-display__link[data-anchor-target]');
    var tabLinks = root.querySelectorAll('button.eofy-products-display__link, a.eofy-products-display__link');
    var scrollOffset = parseInt(root.dataset.scrollOffset || '75', 10);
    var enableSticky = root.dataset.enableSticky === 'true';
    var stickyTriggerSelector = root.dataset.stickyTriggerSelector || '';
    var scrollLock = false;

    function getHeaderOffset() {
      var header = document.querySelector('.site-header');
      return header ? header.offsetHeight : 0;
    }

    function scrollToTarget(selector) {
      if (!selector) return;
      var target;
      try {
        target = document.querySelector(selector);
      } catch (e) {
        return;
      }
      if (!target) return;

      scrollLock = true;
      var top = target.getBoundingClientRect().top + window.pageYOffset;
      var offset = getHeaderOffset() + scrollOffset;
      if (nav && root.classList.contains('eofy-products-display-sticky')) {
        offset += nav.offsetHeight;
      }
      top = Math.max(0, top - offset);

      window.scrollTo({ top: top, behavior: 'smooth' });
      window.setTimeout(function () {
        scrollLock = false;
      }, 700);
    }

    function isNavUnfixed() {
      return nav && !nav.classList.contains('is-fixed');
    }

    function isNavFixed() {
      return nav && nav.classList.contains('is-fixed');
    }

    function pushGa4Event(eventName, eventParameters) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event_parameters: null });
      window.dataLayer.push({
        event: 'ga4Event',
        event_name: eventName,
        event_parameters: eventParameters,
      });
    }

    function isRootInView() {
      var rect = root.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var visible = Math.min(rect.bottom, vh) - Math.max(rect.top, 0);
      return visible >= rect.height * 0.33;
    }

    function getButtonName(link) {
      var name = link.getAttribute('data-button-name');
      if (name) return name.trim();
      var titleEl = link.querySelector('.eofy-products-display__title');
      if (titleEl) return titleEl.textContent.trim();
      var aria = link.getAttribute('aria-label');
      return aria ? aria.trim() : '';
    }

    function pushSelectItemCategoryGa4(buttonName) {
      if (!buttonName) return;
      pushGa4Event('select_item_category', { button_name: buttonName });
    }

    function pushTopNavigationGa4(link) {
      if (!link) return;
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event_parameters: null });
      window.dataLayer.push({
        event: 'ga4Event',
        event_name: 'top_navigation',
        event_parameters: {
          navigation_group: "new_arrivals",
          navigation_name: "new_arrivals_null",
        },
      });
    }

    function setActiveLink(activeLink) {
      anchorLinks.forEach(function (link) {
        link.classList.toggle('is-active', link === activeLink);
      });
    }

    tabLinks.forEach(function (link) {
      link.addEventListener('click', function () {
        if (isNavUnfixed()) {
          pushSelectItemCategoryGa4(getButtonName(link));
        } else if (isNavFixed()) {
          pushTopNavigationGa4(link);
        }

        var selector = link.getAttribute('data-anchor-target');
        if (!selector) return;

        setActiveLink(link);
        scrollToTarget(selector);

        var list = root.querySelector('.eofy-products-display__list');
        if (list && window.matchMedia('(max-width: 749px)').matches) {
          var item = link.closest('.eofy-products-display__item');
          if (item) {
            list.scrollTo({
              left: item.offsetLeft - 24,
              behavior: 'smooth',
            });
          }
        }
      });
    });

    function updateSticky() {
      if (!enableSticky || !nav || !stickyTriggerSelector) return;
      var trigger;
      try {
        trigger = document.querySelector(stickyTriggerSelector);
      } catch (e) {
        return;
      }
      if (!trigger) return;

      var triggerBottom = trigger.offsetTop + trigger.offsetHeight;
      var shouldFix = window.pageYOffset >= triggerBottom;

      if (shouldFix && !root.classList.contains('eofy-products-display-sticky')) {
        if (fillFixed) {
          fillFixed.hidden = false;
          fillFixed.style.height = nav.offsetHeight + 'px';
        }
        root.classList.add('eofy-products-display-sticky');
        nav.classList.add('is-fixed');
        tryPushViewBannerStickyGa4();
      } else if (!shouldFix && root.classList.contains('eofy-products-display-sticky')) {
        root.classList.remove('eofy-products-display-sticky');
        nav.classList.remove('is-fixed');
        if (fillFixed) {
          fillFixed.hidden = true;
          fillFixed.style.height = '0';
        }
      }
    }

    function updateActiveOnScroll() {
      if (scrollLock || !anchorLinks.length) return;

      var offset = getHeaderOffset() + scrollOffset + (nav ? nav.offsetHeight : 0);
      var activeLink = null;

      anchorLinks.forEach(function (link) {
        var selector = link.getAttribute('data-anchor-target');
        if (!selector) return;
        var target;
        try {
          target = document.querySelector(selector);
        } catch (e) {
          return;
        }
        if (!target) return;

        var top = target.getBoundingClientRect().top;
        if (top - offset <= 40) {
          activeLink = link;
        }
      });

      if (activeLink) {
        setActiveLink(activeLink);
      }
    }

    function tryPushViewBannerGa4() {
      if (root.dataset.eofyProductsDisplayViewBanner === 'true') return false;
      if (!isNavUnfixed() || !isRootInView()) return false;
      pushViewBannerMidNavGa4();
      return true;
    }

    function tryPushViewBannerStickyGa4() {
      if (root.dataset.eofyProductsDisplayViewBannerSticky === 'true') return false;
      if (!isNavFixed()) return false;
      pushViewBannerTopNavGa4();
      return true;
    }

    window.addEventListener('scroll', function () {
      updateSticky();
      updateActiveOnScroll();
      if (tryPushViewBannerGa4() && viewBannerObserver) {
        viewBannerObserver.unobserve(root);
      }
    }, { passive: true });

    updateSticky();
    if (anchorLinks.length) {
      setActiveLink(anchorLinks[0]);
    }

    var viewBannerObserver = null;

    function pushViewBannerMidNavGa4() {
      root.dataset.eofyProductsDisplayViewBanner = 'true';
      pushGa4Event('view_banner', {
        creative_slot: 'mid_nav',
        position: '1',
        creative_name: 'product_nav',
      });
    }

    function pushViewBannerTopNavGa4() {
      root.dataset.eofyProductsDisplayViewBannerSticky = 'true';
      pushGa4Event('view_banner', {
        creative_slot: 'top_nav',
        position: '2',
        creative_name: 'product_nav',
      });
    }

    if ('IntersectionObserver' in window) {
      viewBannerObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          if (tryPushViewBannerGa4()) {
            viewBannerObserver.unobserve(entry.target);
          }
        });
      }, { threshold: 0.33 });
      viewBannerObserver.observe(root);
    }

    tryPushViewBannerGa4();
    tryPushViewBannerStickyGa4();
  }

  function boot() {
    document.querySelectorAll('eofy-products-display').forEach(initEofyProductsDisplay);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('eofy-products-display');
    if (root) initEofyProductsDisplay(root);
  });
})();
